<template>
    <div id="profile-heading-container" class="shadow-reg p-3 row mb-4">
        <div class="col-auto image-container">
            <avatar-badge :src="displayImage" update-event="display-image-updated" :raised="false" :size="160"></avatar-badge>
        </div>
        <div id="profile-heading" class="col">
            <h2 class="display-4 montserrat-bold mb-0" v-text="shop.name"></h2>
            <div class="mt--2 heading-small" v-text="displayedAddress"></div>
            <div v-if="shop.mobile_no" class="mt--2 heading-small" v-text="mobileNo"></div>
            <div v-else class="mt--2 heading-small text-muted">No mobile number</div>
            <div v-if="shop.landline_no" class="mt--2 heading-small" v-text="landlineNo"></div>
            <div v-else class="mt--2 heading-small text-muted">No landline number</div>
            
            <router-link :to="bookingViaShopLink" v-slot="{ href, navigate }">
                <a :href="href" @click="navigate" class="btn btn-warning mt-2">Book a shop appointment</a>
            </router-link>
        </div>
    </div>
</template>
<script>
import { resource } from "@utils/network";
export default {
    name: "ShopHeading",

    computed: {
        displayedAddress() {
            return this.shop.address ? this.shop.address.display_name : "";
        },
        bookingViaShopLink() {
            return `/bookings/create/${ this.shop.id }`;
        },
        displayImage() {
            return this.shop.display_image || resource("images/placeholders/avatar.jpg");
        },
        mobileNo() {
            return this.shop.mobile_no;
        },
        landlineNo() {
            return this.shop.landline_no;
        },
    },

    props: {
        shop: [Object],
    },
}
</script>
<style lang="css" scoped>
    #profile-heading-container {
        border-radius: 6px;
        background-color: white;
    }
    #profile-heading-container .image-container {
        padding: 0px 15px 0px;
    }
    #profile-heading {
        padding: 0px 19px 0px;
    }
</style>